module.exports = __webpack_public_path__ + "static/media/robin-mandal.522155a2.png";